import { request as __request } from '../core/request';
export class BackendUserService {
    /**
     * @returns any Success
     * @throws ApiError
     */
    static getDeletedList() {
        return __request({
            method: 'GET',
            path: `/api/backend/user/deleted_list`,
        });
    }
    /**
     * @returns any Success
     * @throws ApiError
     */
    static batchDelete({ requestBody, }) {
        return __request({
            method: 'POST',
            path: `/api/backend/user/batch_delete`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any Success
     * @throws ApiError
     */
    static batchRecovery({ requestBody, }) {
        return __request({
            method: 'POST',
            path: `/api/backend/user/recovery`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * [BASE] Search From UserEntity
     * @returns any Success
     * @throws ApiError
     */
    static findAll({ where, page, }) {
        return __request({
            method: 'GET',
            path: `/api/backend/user`,
            query: {
                'where': where,
                'page': page,
            },
        });
    }
    /**
     * [BASE] Add To UserEntity
     * @returns any Success
     * @throws ApiError
     */
    static add({ requestBody, }) {
        return __request({
            method: 'POST',
            path: `/api/backend/user`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * [BASE] Batch Update To UserEntity
     * @returns void
     * @throws ApiError
     */
    static batchUpdate({ requestBody, }) {
        return __request({
            method: 'PUT',
            path: `/api/backend/user`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * [BASE] FindOne From UserEntity
     * @returns any Success
     * @throws ApiError
     */
    static findOne({ id, }) {
        return __request({
            method: 'GET',
            path: `/api/backend/user/${id}`,
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * [BASE] Update To UserEntity
     * @returns any Success
     * @throws ApiError
     */
    static update({ id, requestBody, }) {
        return __request({
            method: 'PUT',
            path: `/api/backend/user/${id}`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * [BASE] Delete From UserEntity
     * @returns void
     * @throws ApiError
     */
    static delete({ id, softDelete, }) {
        return __request({
            method: 'DELETE',
            path: `/api/backend/user/${id}`,
            query: {
                'softDelete': softDelete,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
